"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toFullyQualifiedUrl = toFullyQualifiedUrl;
function toFullyQualifiedUrl(params) {
    var url;
    if (params.urlish.startsWith("http")) {
        url = params.urlish;
    }
    else {
        var path = params.urlish;
        if (!path.startsWith("/")) {
            path = "/".concat(path);
        }
        url = "".concat(window.location.origin).concat(path);
    }
    {
        var urlObj = new URL(url);
        urlObj.pathname = urlObj.pathname
            // Make sure there is no double slash like in `https://example.com//foo//bar`
            .replace(/\/\//g, "/");
        url = urlObj.href;
    }
    if (params.doAssertNoQueryParams) {
        if (new URL(url).searchParams.size !== 0) {
            throw new Error("The ".concat(params.urlish, " URL should not have query parameters"));
        }
        if (params.doOutputWithTrailingSlash) {
            if (!url.endsWith("/")) {
                url = "".concat(url, "/");
            }
        }
        else {
            if (url.endsWith("/")) {
                url = url.slice(0, -1);
            }
        }
    }
    return url;
}
//# sourceMappingURL=toFullyQualifiedUrl.js.map